import { CustomInput } from '@globalmed/atlas-ui';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FormBuilderDropdown.module.css';

type TProps = {
  value: string;
  error?: boolean;
  onValueChange: (value: string) => void;
};

export const FormBuilderDropdown =
  /**
   * Dropdown field component for form builder
   * @param {TProps} props - Component props
   * @param {string} props.value - Current dropdown value
   * @param {boolean} [props.error=false] - Whether the field has validation errors
   * @param {Function} props.onValueChange - Callback when value changes
   * @returns {JSX.Element} Form builder dropdown component
   */
  memo(({ value, error = false, onValueChange }: TProps) => {
    const { t } = useTranslation();
    return (
      <CustomInput
        placeholder={t('form-builder.write-your-answer-here')}
        aria-label={t('form-builder.write-your-answer-here')}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className={error ? styles.error : undefined}
      />
    );
  });

FormBuilderDropdown.displayName = 'FormBuilderDropdown';
